<template>
  <b-modal
    :id="
      groupData ? `modal-edit-action-group-${groupData._id}` : 'modal-new-group'
    "
    size="md"
    centered
    :title="
      groupData
        ? `${$t('actionGroup.editGroup')} ${groupData.name}`
        : $t('actionGroup.newGroup')
    "
    okTitle="Salvar"
    @ok="saveGroup"
    @show="modalData"
  >
    <div>
      <div class="group-form">
        <div>
          <label for="group-name"> {{ $t('actionGroup.groupName') }}: </label>
          <input
            id="group-name"
            type="text"
            class="form-control"
            v-model="group.name"
            :placeholder="$t('actionGroup.placeholderGroupName')"
          />
        </div>
        <div class="p-0 mt-3 col-6">
          <label for="metric"> {{ $t('actionGroup.metric') }}: </label>
          <div>
            <b-form-select
              :disabled="!!groupData"
              v-model="group.metric"
              :options="options"
            >
            </b-form-select>
          </div>
        </div>
        <div v-if="!groupData" class="mt-3 favorite">
          <b-form-checkbox v-model="group.favourite" id="favourite">
          </b-form-checkbox>
          <label for="favourite" class="m-0">
            {{ $t('actionGroup.favoriteGroup') }}
          </label>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import swal from 'sweetalert';
import { mapActions } from 'vuex';
import api from '../../../../services/api';

export default {
  props: ['groupData', 'updateActionGroupTable'],

  data: () => ({
    group: {},
    userAuth: null,
    selectedNps: null,
    options: [],
  }),

  methods: {
    ...mapActions('actions', ['getAllActionGroups']),

    modalData() {
      this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

      if (this.groupData) {
        this.group = { ...this.groupData };
      } else {
        this.group = { metric: 'nps-0-10' };
      }
    },

    async saveGroup(event) {
      if (!this.group.name) {
        event.preventDefault();

        swal({
          title: this.$t('actionGroup.messages.saveError.title'),
          text: this.$t('actionGroup.messages.saveError.description'),
          icon: 'warning',
        });
      } else if (this.groupData) {
        await api.put(
          `${process.env.API_ROOT}/action-group/${this.userAuth.companyId}/${this.groupData._id}`,
          {
            name: this.group.name,
            active: this.group.active,
            favourite: this.group.favourite,
          },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );
        swal({
          icon: 'success',
          title: this.$t('actionGroup.messages.edited.title'),
          text: `${this.group.name} -
            ${this.$t('actionGroup.messages.edited.description')}`,
        });

        this.getAllActionGroups({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          params: {
            menuAside: false,
          },
        });

        this.updateActionGroupTable();
      } else {
        await api.post(
          `${process.env.API_ROOT}/action-group/${this.userAuth.companyId}`,
          {
            name: this.group.name,
            favourite: this.group.favourite,
            metric: this.group.metric,
          },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );

        swal({
          icon: 'success',
          title: this.$t('actionGroup.messages.created.title'),
          text: `${this.group.name} -
            ${this.$t('actionGroup.messages.created.description')}`,
        });

        this.getAllActionGroups({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          params: {
            menuAside: false,
          },
        });

        this.updateActionGroupTable();
      }
    },
  },
  created() {
    this.options = [
      { value: 'nps-1-5', text: this.$t('actionGroup.nps15') },
      { value: 'nps-0-10', text: this.$t('actionGroup.nps010') },
      { value: 'ces-1-5', text: this.$t('actionGroup.ces15') },
      { value: 'csat-1-5', text: this.$t('actionGroup.csat15') },
      { value: 'csat-1-5(media)', text: this.$t('actionGroup.csatAverage15') },
      { value: 'csat-0-10(media)', text: this.$t('actionGroup.csat0to10Average') },
      { value: '5-stars', text: this.$t('actionGroup.fiveStars') },
      { value: 'like-dislike', text: this.$t('actionGroup.likeDislike') },
    ];
  },
};
</script>
<style scoped>
.favorite {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/action-group/Modal-Action-Group/index.vue